import React from 'react';
import '../../../styles/site.css';

const Footer = (props) => {
    return (
        <div className="row cs-footer">
            <div className="col-2 left-footer" />
            <div className="col-10 right-footer">
                {/* <div className="col-sm-12 col-banner"> */}
                {/* <img src="https://csintercelulas.s3.amazonaws.com/code/media/febanner.png" className="img-responsive fe-banner" alt="" /> */}
                {/* <img src="https://appsd.compusoluciones.com/csEstilos/csImagenes/imgSistema.png" className="img-responsive fe-banner" alt="" /> */}

            </div>
        </div>
    )
}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (prevProps.start === nextProps.start);
}

export default React.memo(Footer, validaProps);
